import { Component, Prop } from '@stencil/core';
import { ShortPrice, PriceCalculation } from '../../../types/types';
import { Unsubscribe } from '@stencil/redux';
import { store } from '../../../redux/store';
import { RootState } from '../../../redux/reducers';
import { formatPrice, t } from '../../../redux/utils';
import { FreeOfCharge } from '../../../types/config';

@Component({
  tag: 'rentware-item-price',
  styleUrl: 'style.sass',
  shadow: false,
})
export class RentwareItemPrice {
  @Prop() price: ShortPrice;
  @Prop() mileagePrice?: ShortPrice; //you can pass price and mileage separately or calculated total price as the price only
  @Prop({ mutable: true }) type: string; // per hour, day etc.
  @Prop({ mutable: true }) displayNet: boolean;
  @Prop({ mutable: true }) freeOfCharge: FreeOfCharge;

  unsubscribe!: Unsubscribe;

  componentWillLoad() {
    this.unsubscribe = store.mapStateToProps(this, (state: RootState) => {
      return {
        displayNet: state.system.pricing?.priceDisplay === 'net',
        type: this.type ?? state.system.pricing?.itemPriceCalculation, // passed type in attribute wins with redux state
        freeOfCharge: state.system.widgetConfig.advanced.general.freeOfCharge,
      };
    });
  }

  disconnectedCallback() {
    this.unsubscribe();
  }

  get transPrice() {
    if (!this.price) {
      return null;
    }

    const price = this.displayNet ? this.price.net : this.price.gross

    const transParams = { amount: formatPrice(price) };

    if (price === 0) {
      if (this.freeOfCharge === FreeOfCharge.Number) {
        return t('checkout.priceInterval', transParams);
      } else {
        return t('payment.free');
      }
    }

    const priceType = this.price.priceCalculation ?? this.type

    if (priceType === PriceCalculation.Interval) {
      return t('checkout.priceInterval', transParams);
    }
    if (priceType === PriceCalculation.Hour) {
      return t('checkout.pricePerHour', transParams);
    }
    if (priceType === PriceCalculation.Day) {
      return t('checkout.pricePerDay', transParams);
    }
    if (priceType === PriceCalculation.CalendarDay) {
      return t('checkout.pricePerCalendarDay', transParams);
    }
    if (priceType === PriceCalculation.Night) {
      return t('checkout.pricePerNight', transParams);
    }
    if (priceType === PriceCalculation.Month) {
      return t('checkout.pricePerMonth', transParams);
    }

    return null;
  }

  render() {
    return this.transPrice;
  }
}
